import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import DateTimeUtils from "../../services/DateTimeUtils";
import ApiService from "../../services/ApiService";
import AppRoute from "../../utils/AppRoute";

const CardParticipant = ({participantIndex, participant, refresh, setError}) => {

    const handleEliminaPartecipante = async () => {

        ApiService.deleteParticipantById(participant.id).then((response) => {
            if(response.ok){
                refresh(new Date().getMilliseconds())
            } else if(response.status === 400) {
                setError({
                    state: true,
                    title: "Impossibile eliminare un partecipante iscritto ad un corso",
                    body: "Ok"
                })
            } else {
                setError({
                    state: true,
                    title: "Errore nell'eliminazione del partecipante",
                    body: "Riprova"
                })
            }
        })
    }

    return (
        <>
            {participant &&
                <>
                    <p className={'fw-bold mb-1'}>Partecipante {participantIndex}</p>
                    <Row className="card card-participant g-0 mb-3">
                        <Col xs={12} sm={6} md={6}>
                            <div className={'py-1 px-2 p-md-2'}>
                                {participant.firstName} {participant.lastName}
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <div className={'py-1 px-2 p-md-2'}>
                                {DateTimeUtils.getParticipantDob(participant)}
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <div className={'py-1 px-2 p-md-2'}>
                                {participant.currentLevel}
                            </div>
                        </Col>
                    </Row>
                    <div className={'d-flex flex-column justify-content-end align-items-end'}>
                        <Link to={AppRoute.PARTICIPANT} state={{editMode: true, participantId: participant.id}} className={'btn btn-primary px-5 fw-bold'}>Modifica</Link>
                        <Button variant={'link'} onClick={(e) => handleEliminaPartecipante(e)}>Elimina</Button>
                    </div>
                </>
            }
        </>
    )

}
export default CardParticipant;